import { appConfig } from 'cd-eft/config/AppConfig';

export const DESIGN = 'Files';
export const REPORT = 'Report';
export const ANALYSIS = 'Files';

// Tabs and Dropdown Options
export const OUTPUT_TABS = {
  1: {
    tabs: [
      {
        tab: DESIGN,
        title: DESIGN,
        label: 'Select File Format',
        options: [
          { name: 'LandXML', value: 'LandXML' },
          { name: 'ESRI Shape File', value: 'ESRI' },
          { name: 'CSV', value: 'CSV' },
          { name: 'Images', value: 'Images' },
          { name: 'DEM', value: 'DEM' },
        ],
      },
      {
        tab: REPORT,
        title: REPORT,
        label: 'Select Report Type',
        options: [
          { name: 'Construction', value: 'Construction' },
          { name: 'Design', value: 'Design' },
          { name: 'Project Summary', value: 'Project' },
        ],
      },
    ],
  },
  4: {
    tabs: [
      {
        tab: ANALYSIS,
        title: ANALYSIS,
        label: 'Select File Format',
        options: [
          { name: 'Hydro Metadata', value: 'HydroMetadata' },
          { name: 'Images', value: 'AnalysisImages' },
        ],
      },
      {
        tab: REPORT,
        title: REPORT,
        label: 'Select Report Type',
        options: [
          { name: 'Hydrology', value: 'Hydrology' },
          { name: 'Project Summary', value: 'HydrologyProjectSummary' },
        ],
      },
    ],
  },
};

// Output types depending on Dropdown Option
export const OUTPUT_fileFormats = {
  all: {
    validTypes: [
      appConfig.hardCodes.designElementTypeDrawing, // 1 Drawing
      appConfig.hardCodes.designElementTypeSuface, // 2 Surface
      10, // DEM
      appConfig.hardCodes.designElementTypeIndependent, // 5 Alignment
      // appConfig.hardCodes.designElementTypeWaterway 7 Waterway
      appConfig.hardCodes.designElementTypePitRectangular, // 11 Pit Rectangular
      appConfig.hardCodes.designElementTypePitRound, // 12 Pit Round
      appConfig.hardCodes.designElementTypePitDiked, // 13 Pit Diked
      appConfig.hardCodes.designElementTypePad, // 14 Pad
      appConfig.hardCodes.designElementTypeLandLeveling, // 15 Land Leveling
      appConfig.hardCodes.designElementTypeSpredsheet, // 16 Spreadsheet Alignment
      appConfig.hardCodes.designElementTypeCrossSlope, // 17 CrossSlope Alignment
      'Survey',
      'Waterway',
      'Survey - DEM Surface',
    ],
  },
  ESRI: {
    validTypes: [
      appConfig.hardCodes.designElementTypeSuface,
      'Survey - DEM Surface',
      appConfig.hardCodes.designElementTypeIndependent,
      appConfig.hardCodes.designElementTypePitRectangular,
      appConfig.hardCodes.designElementTypePitRound,
      appConfig.hardCodes.designElementTypePitDiked,
      appConfig.hardCodes.designElementTypePad,
      appConfig.hardCodes.designElementTypeLandLeveling,
      'Waterway',
      'Terrace'

    ],
    errorMsg:
      'You must choose at least one Pit/Pad/Land Leveling, Surface or Waterway element to generate ESRI Shape File',
  },
  DEM: {
    validTypes: [
      10
    ],
    errorMsg:
      'You must choose at least one element to generate DEM',
  },
  LandXML: {
    validTypes: [
      appConfig.hardCodes.designElementTypeDrawing,
      appConfig.hardCodes.designElementTypeSuface,
      'Survey - DEM Surface',
      appConfig.hardCodes.designElementTypeIndependent,
      appConfig.hardCodes.designElementTypePitRectangular,
      appConfig.hardCodes.designElementTypePitRound,
      appConfig.hardCodes.designElementTypePitDiked,
      appConfig.hardCodes.designElementTypePad,
      appConfig.hardCodes.designElementTypeLandLeveling,
      'Waterway',
      'Terrace System',
    ],
    errorMsg: 'You must choose Pit/Pad/Land Leveling, Surface or Drawing to generate LandXML',
  },
  CSV: {
    validTypes: [
      appConfig.hardCodes.designElementTypeIndependent,
      appConfig.hardCodes.designElementTypeLandLeveling,
      'Survey',
      'Waterway',
      'Terrace',
    ],
    errorMsg: 'You must choose at least one Alignment/Survey/Waterway/Terrace to generate a CSV',
  },
  Construction: {
    validTypes: [
      appConfig.hardCodes.designElementTypePitRectangular,
      appConfig.hardCodes.designElementTypePitRound,
      appConfig.hardCodes.designElementTypePitDiked,
      appConfig.hardCodes.designElementTypePad,
      appConfig.hardCodes.designElementTypeLandLeveling,
      'Waterway',
      'Terrace System'
    ],
    errorMsg: 'You must choose at least one Pit/Pad/Land Leveling to generate a Report',
  },
  Design: {
    validTypes: ['Waterway', 'Terrace'],
    errorMsg: 'You must choose at least one Waterway to generate a Report',
  },
  Project: {
    validTypes: [
      // 'ProjectAdditionalInformation',
      // appConfig.hardCodes.designElementTypeSuface,
      // appConfig.hardCodes.designElementTypePitRectangular,
      // appConfig.hardCodes.designElementTypePitRound,
      // appConfig.hardCodes.designElementTypePitDiked,
      // appConfig.hardCodes.designElementTypePad,
      // appConfig.hardCodes.designElementTypeLandLeveling,
      // appConfig.hardCodes.designElementTypeIndependent,
      // 'Waterway',
    ],
    errorMsg: 'You must choose at least one element to generate a Report',
  },
  Images: {
    validTypes: [
      appConfig.hardCodes.designElementTypeSuface,
      'Survey - DEM Surface',
      appConfig.hardCodes.designElementTypePitRectangular,
      appConfig.hardCodes.designElementTypePitRound,
      appConfig.hardCodes.designElementTypePitDiked,
      appConfig.hardCodes.designElementTypePad,
      appConfig.hardCodes.designElementTypeLandLeveling,
      appConfig.hardCodes.designElementTypeIndependent,
      'Waterway',
      'Terrace System'
    ],
    errorMsg: 'You must choose at least one image to generate a Report',
  },
  HydroMetadata: {
    validTypes: ['DetailFiles', 'GISFiles'],
    errorMsg: 'You must choose at least one object to generate a Report',
  },
  AnalysisImages: {
    validTypes: [],
    errorMsg: 'You must choose at least one object to generate a Report',
  },
  Hydrology: {
    validTypes: ['AdditionalInformation'],
    errorMsg: 'You must choose at least one element to generate a Report',
  },
  HydrologyProjectSummary: {
    validTypes: [],
    errorMsg: 'You must choose at least one object to generate a Report',
  },
};

// Informational Types
export const OUTPUT_TYPES = {
  DetailFiles: { label: 'Download Hydrology Detail Files', options: [] },
  GISFiles: { label: 'Download Hydrology GIS Files', options: [] },
  AdditionalInformation: {
    label: 'Additional Information',
    options: [
      { value: 'runoff', label: 'Runoff Hydrograph' },
      { value: 'aoi', label: 'AOI Map' },
      { value: 'rainfall', label: 'Rainfall Distribution Data' },
      { value: 'precipitation', label: 'Precipitation Frequency Data' },
      { value: 'storm', label: 'Storm Analysis' },
      { value: 'peak', label: 'Runoff and Peak Discharge Data' },
      { value: 'dem', label: 'DEM Service Data' },
    ],
  },
  ProjectAdditionalInformation: {
    label: 'Additional Information',
    options: [
      { value: 'activitySummary', label: 'Activity Summary' },
      { value: 'comments', label: 'Comments' },
      { value: 'propjectHistory', label: 'Project History' },
      { value: 'image', label: 'Image' },
    ],
  },
};

export const OUTPUT_IMAGE_TYPES = {
  0: 'Plan Map (System Generated)',
  1: 'Plan Map',
  2: 'Location Map',
  3: 'Other Map',
  4: 'Three CrossSection',
  5: 'Single CrossSection',
};
